<template>
    <tr :class="{ 'reverted-muted': entry.revertsTransaction !== null || entry.revertedBy !== null }">
        <td>{{ entry.id}}</td>
        <td>{{ $filters.formatDate(entry.date) }}</td>
        <td>{{ entry.text }}
            <span v-if="entry.category" class="badge" :style="{ color: '#fff', float: 'right', backgroundColor: entry.category.background_color }">{{ entry.category.name }}</span>
        </td>
        <td style="display: flex; width: 100%">
            <span style="margin-right: auto">
                {{ entry.receiptInfo }}
            </span>
            <span v-show="ownGroup=='admin'" style="margin-left: 1em">
                <a
                    href="#"
                    @click="$emit('change-receipt-info', entry)"
                    title="Kassenanordnungsnummer ändern"
                >
                    <i class="fas fa-edit fa-fw fa-lg text-secondary"></i>
                </a>
            </span>
        </td>
        <td style="text-align: right" v-if="entry.rx_amount != 0">{{ computeValue(entry.rx_amount) }}</td>
        <td v-else></td>
        <td style="text-align: right" v-if="entry.tx_amount != 0">{{ computeValue(entry.tx_amount) }}</td>
        <td v-else></td>
        <td style="text-align: right">{{ computeValue(entry.balance) }}</td>
        <td class="d-flex align-items-end flex-column" style="">
            <div style="width: 5.0em">
                <a
                    href="#"
                    @click="emitDownloadReceipt($event, entry)"
                    title="Belege runterladen"
                    v-if="entry.revertsTransaction === null"
                >
                    <i class="fas fa-receipt fa-fw fa-lg text-secondary"></i>
                </a>
                <a
                    href="#"
                    @click="emitDownloadDocument($event, entry)"
                    title="Kassenanordnung runterladen"
                >
                    <i class="far fa-file fa-fw fa-lg text-secondary"></i>
                </a>
                <a
                    href="#"
                    @click="emitReverseTransaction($event, entry)"
                    title="Buchung stornieren"
                    v-if="entry.revertsTransaction === null && entry.revertedBy === null"
                >
                    <i class="fas fa-undo fa-fw fa-lg text-danger"></i>
                </a>
            </div>
            
        </td>
    </tr>
</template>
<script>

const api_url = process.env.VUE_APP_ROOT_API;

export default {
    name: 'EntryRow',
    props: {
        accountName: "",
        entry: {
            type: Object,
            required: true
        },
        ownGroup: "",
    },
    computed: {

    },
    methods: {
        computeValue: function(amount) {
            var num = new Number(amount / 100);
            return parseFloat(Math.round(num * 100) / 100)
                .toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        },
        emitDownloadReceipt(event, entry) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('download-receipt', entry);
        },
        emitDownloadDocument(event, entry) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('download-document', entry);
        },
        emitReverseTransaction(event, entry) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('reverse-transaction', entry);
        },
    },
    mounted() {
        console.log("EntryRow mounted");
    },
    beforeMount() {
        console.log("EntryRow beforeMount");
    },
    afterMount() {
        console.log("EntryRow afterMount");
    },
    beforeUnmount() {
        console.log('EntryRow component beforeDestroy');
    },
    beforeCreate() {
        console.log('EntryRow component beforeCreate');
    },
}
</script>

<style scoped>
.reverted-muted {
    color: rgb(193, 193, 193) !important;
}
</style>
